import humps from 'humps';
import { isPlural } from 'pluralize';

export function toResourceName(actionName, resource) {
  const capName = humps.pascalize(resource);
  if (isPlural(capName)) {
    return actionName.replace(capName, 'Resources');
  }
  const resourceName = actionName.replace(capName, 'Resource');
  return resourceName;
}

export function toSliceName(actionName, resource) {
  const sliceName = `${toResourceName(actionName, resource)}Slice`;
  return sliceName;
}

export function toRealName(actionName, resource) {
  const capName = humps.pascalize(resource);
  if (isPlural(capName)) {
    return actionName.replace('Resources', capName);
  }
  return actionName.replace('Resource', capName);
}

export function keysToRealName(resource) {
  return (object) => {
    return Object.keys(object).reduce(
      (result, key) => ({
        ...result,
        [toRealName(key, resource)]: object[key],
      }),
      {}
    );
  };
}
